import { SearchFilter } from '../utils';
import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';

export class CategoryAPIClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/category');
  }

  async search(query: any, page: number, size: number, meta: MetaQuery | undefined): Promise<any> {
    try {
      const levelFilter = query.filters.find((f: SearchFilter) => f.field === 'level');
      if (!levelFilter) {
        return [];
      }

      if (levelFilter.value === 'SUB_CATEGORY') {
        const categoryIdFilter = query.filters.find((f: SearchFilter) => f.field === 'parentId');
        if (!categoryIdFilter) {
          return [];
        }
      }

      if (levelFilter.value === 'PRODUCT_TYPE') {
        const subCategoryIdFilter = query.filters.find((f: SearchFilter) => f.field === 'parentId');
        if (!subCategoryIdFilter) {
          return [];
        }
      }

      return await super.search(query, page, size, meta);
    } catch (error) {
      console.error(`Error searching entities with Query:`, query, error);
      throw error;
    }
  }
}

export default CategoryAPIClient;
